import * as storage from './storage';
const pulseStorageKeys = {
    PULSE_PPID_STORAGE_KEY: '_pulse.internal.identity.ppid',
    PULSE_CIS_CACHE_STORAGE_KEY: '_pulse.internal.identity.cis',
};
const getPPIDsFromStorage = () => {
    try {
        const webStorage = storage.getStorage();
        return JSON.parse(webStorage.getItem(pulseStorageKeys.PULSE_PPID_STORAGE_KEY) ?? '');
    }
    catch (err) {
        return {};
    }
};
const setPPIDsToStorage = (ppid) => {
    try {
        const webStorage = storage.getStorage();
        webStorage.setItem(pulseStorageKeys.PULSE_PPID_STORAGE_KEY, JSON.stringify(ppid));
        return true;
    }
    catch (err) {
        return false;
    }
};
const getCisCacheFromStorage = () => {
    try {
        const webStorage = storage.getStorage();
        return JSON.parse(webStorage.getItem(pulseStorageKeys.PULSE_CIS_CACHE_STORAGE_KEY) ?? '');
    }
    catch (err) {
        return {};
    }
};
const setCisCacheToStorage = (cisPayload) => {
    try {
        const webStorage = storage.getStorage();
        webStorage.setItem(pulseStorageKeys.PULSE_CIS_CACHE_STORAGE_KEY, JSON.stringify(cisPayload));
        return true;
    }
    catch (err) {
        return false;
    }
};
export default {
    getCisCacheFromStorage,
    setCisCacheToStorage,
    getPPIDsFromStorage,
    setPPIDsToStorage,
};
//# sourceMappingURL=pulseStorage.js.map